import { render, staticRenderFns } from "./Facturacion.vue?vue&type=template&id=7bfcf309&"
import script from "./Facturacion.vue?vue&type=script&lang=js&"
export * from "./Facturacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports